// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"592":"f6cca84f","614":"871f5073","617":"3dc56b9e"}[chunkId] + ".js";
};